import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const answers = [{
  q: 'How much does ducted aircon cost in Perth?',
  a: 'Ducted reverse cycle installation in Perth typically ranges A$10,000 to A$20,000 fully installed, depending on home size, zoning and brand. Langler Air quotes fixed price on site.',
  src: 'Verified Langler Air pricing'
}, {
  q: 'Which AC brand is best for Perth?',
  a: 'Mitsubishi Electric, Daikin and Rinnai are reliable choices for Perth conditions. Langler Air is a Mitsubishi Electric Diamond Dealer and installs all three.',
  src: 'Langler Air installation experience'
}, {
  q: 'How long does installation take?',
  a: 'A single split system is usually installed in one day. Ducted reverse cycle installations take two to three days depending on home size and zoning complexity.',
  src: 'Typical installation timing'
}, {
  q: 'Do you service my Perth suburb?',
  a: 'Langler Air installs across Perth metropolitan suburbs and regional Western Australia, working from our Balcatta workshop at Unit 2/3 Cressall Rd, WA 6021.',
  src: 'Verified service area'
}, {
  q: 'What is reverse cycle air conditioning?',
  a: 'Reverse cycle uses one system to heat and cool. It is an efficient way to heat and cool a Perth home throughout the year.',
  src: 'System overview'
}, {
  q: 'Do you offer a warranty?',
  a: 'Every Langler Air installation carries a workmanship guarantee plus the full manufacturer warranty on all major brand units we install.',
  src: 'Langler Air guarantee'
}, {
  q: 'What size air conditioner do I need?',
  a: 'Sizing depends on room dimensions, ceiling height, insulation and orientation. Every Langler Air recommendation starts with an on-site assessment.',
  src: 'Langler installation standard'
}, {
  q: 'Can I get finance for an air conditioner?',
  a: 'Yes. Langler Air offers finance options through accredited providers. Ask our team at your free quote for current terms.',
  src: 'Langler Air finance options'
}];
export function AEOAnswerHub() {
  return <section id="answers" aria-labelledby="aeo-heading" className="bg-white py-20 md:py-28 scroll-mt-24" data-id="element-26" data-mp="1fopay6z96762">
      <div className="max-w-6xl mx-auto px-6" data-id="element-27" data-mp="1bk9525pn2zqu">
        <div className="max-w-3xl mb-12" data-id="element-28" data-mp="16lxvlw39ar95">
          <div className="kicker mb-3" data-id="element-29" data-mp="16mzicxtmx26p">Straight answers</div>
          <h2 id="aeo-heading" className="text-3xl md:text-5xl font-bold text-ink-900 tracking-tight leading-tight" data-id="element-30" data-mp="11nwaz6q6mjvk">Air conditioning in Perth, answered.</h2>
          <p className="mt-4 text-lg text-stone-600 max-w-2xl" data-id="element-31" data-mp="1zd7rk0670c95">Clear answers based on Langler Air installation experience across Perth since 1995.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-32" data-mp="1pka91u17anaj">
          {answers.map((item, i) => <motion.article key={item.q} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: i * 0.04
        }} className="lift-card bg-white rounded-2xl p-7 border border-stone-200 flex flex-col" itemScope itemType="https://schema.org/Question" data-id="element-33" data-mp="1klpeaa4pwvth" data-mpi={i}>
              <h3 itemProp="name" className="text-lg font-semibold text-ink-900 leading-snug mb-3 tracking-tight" data-id="element-34" data-mp="2uki4enx0t16r">{item.q}</h3>
              <div itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer" className="flex-grow" data-id="element-35" data-mp="2zkcw2tomdusv">
                <p itemProp="text" className="aeo-answer text-base text-stone-700 leading-relaxed" data-id="element-36" data-mp="33k55f8lu84za">{item.a}</p>
              </div>
              <div className="mt-5 pt-4 border-t border-stone-100 flex items-center gap-2 text-xs text-stone-500" data-id="element-37" data-mp="38hn84h99hnyu">
                <CheckCircle2 size={13} className="text-success flex-shrink-0" data-id="element-38" data-mp="3i9t8ae9o3bp4" />
                <span className="font-medium" data-id="element-39" data-mp="3ibw1f7649ky2">{item.src}</span>
              </div>
            </motion.article>)}
        </div>
        <div className="mt-10 text-center" data-id="element-40" data-mp="3r9zls05d8boa">
          <a href="#quote-form" className="inline-flex items-center gap-2 text-brand font-semibold hover:underline" data-id="element-41" data-mp="3rar5aclouiy7">Have a different question? Ask our team →</a>
        </div>
      </div>
    </section>;
}